<template>
  <div v-if="data && data.length">
    <Table :show-download="true" :additional-columns="table.additionalColumns" :columns="table.columns"
           :show-child-rows="true" :data="table.values" :is-selection-active="selectionActive" :show-select="true"
           :options="table.options" @download="download" @select="handleSelectEvent">
    </Table>
  </div>
  <div v-else class="no-data d-flex justify-content-center align-items-center">
    <i v-if="!isReady">No data</i>
  </div>
</template>

<script>
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import _ from 'lodash'
import Table from '../../shared/Table'
import { mapActions, mapGetters } from 'vuex'
import studyGetters from '../../../store/modules/studies/getterTypes'
import studiesActions from '../../../store/modules/studies/actionTypes'
import fileNames from '../../../constants/fileNames'

export default {
  name: 'ConceptsTable',
  components: { Table },
  props: {
    data: {
      type: Array,
      required: false
    },
    isReady: Boolean,
    parseSearchData: Function
  },
  data () {
    return {
      table: {
        columns: ['name', 'concept_code', 'region', 'country', 'links'],
        additionalColumns: [],
        values: []
      },
      selectionActive: false
    }
  },
  computed: {
    ...mapGetters({
      filters: studyGetters.GET_SEARCH_FILTERS
    })
  },
  methods: {
    ...mapActions({
      getXLSX: studiesActions.FETCH_FRAGRANCE_XLSX
    }),
    formatValue (value) {
      if (!value || value === 'No Tag') {
        return '-'
      } else if (typeof value === 'string') {
        return value && value.charAt(0).toUpperCase() + value.slice(1)
      } else {
        return value
      }
    },
    async download () {
      const response = await this.getXLSX({
        q: this.parseSearchData(this.filters)
      })
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileNames.studySearchFragrances)
      document.body.appendChild(link)
      link.click()
    },
    handleSelectEvent ({ type, data = null }) {
      switch (type) {
        case 'edit':
          this.selectionActive = true
          break
        case 'cancel':
          this.selectionActive = false
          break
        case 'confirmEdit':
          this.$emit('multi-study-edit', data)
          this.selectionActive = false
          break
        default:
          this.selectionActive = false
      }
    }
  },
  watch: {
    data (newData) {
      if (newData && newData.length) {
        const dataClone = _.cloneDeep(newData)
        const dataMap = dataClone.map(el => {
          return { ...el.main, ...el.other, ...el.additional }
        })
        dataMap.forEach((el, index) => {
          Object.keys(el).forEach(key => {
            if (key !== 'id') {
              const newValue = this.formatValue(el[key])
              dataMap[index][key] = newValue
            }
          })
        })
        this.table.values = dataMap
      }
    }
  }
}
</script>

<style scoped>
.main-data {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 80px;
  width: 100%;
  cursor: pointer;
}

.additional-data {
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: hidden;
  width: 98%;
  cursor: pointer;
}

.data {
  border-bottom: 1px solid #d1d4d7;
  transition: 0.1s background-color linear;
}

.data:hover {
  background-color: #f6f6f6;
}

.additional-data-hide {
  height: 0;
}

.additional-data-show {
  height: 50px;
  border-top: 1px dashed #d1d4d7
}

.data-show {
  height: 140px;
}

.data-hide {
  height: 90px;
}

.scroller {
  height: 100%;
}

.column-header {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  transition: 0.1s background-color linear;
}

.column-header:hover {
  background-color: #f6f6f6;
}

.column-body {
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-data {
  height: calc(55vh - 4rem);
}

.table-header {
  z-index: 3;
  position: sticky;
  top: 0;
  background-color: white;
  border-bottom: 1px solid #d1d4d7;
  padding: 0 12px;
}

.no-hover:hover {
  background-color: unset;
}

.table-container {
  overflow: scroll;
  position: relative;
  max-height: calc(55vh - 4rem);
  min-height: 523px;
}
</style>
